import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';
import { Badge } from '../../ui/Badge';
import { Link, ExternalLink } from "lucide-react";
const DomainList = ({ domains }) => {
    return (
        <Card className="shadow-elegant">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Link className="h-5 w-5 text-primary" />
                    Domainlerinizin Görüntüleme İstatistiği
                </CardTitle>
                <CardDescription>WebSitesi adreslerinizin performansları</CardDescription>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    {domains.map((page, index) => (
                        <div key={index} className="flex flex-col gap-4 md:gap-0 md:flex-row group items-center justify-between p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors">
                            <div className="w-full flex items-center justify-between gap-4">
                                <div className="flex-shrink-0">
                                    <div className="w-10 h-10 bg-gradientPrimary rounded-lg flex items-center justify-center text-white font-bold">
                                        {index + 1}
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center gap-2">
                                        <p className="font-medium text-foreground">{page.host}</p>
                                        <ExternalLink className="h-3 w-3 text-mutedForeground" />
                                    </div>
                                    <p className="text-sm text-mutedForeground">

                                        {page.pageViews.toLocaleString()} görüntülenme ({page.percentage}%)
                                    </p>
                                </div>
                            </div>
                            <div className="w-full md:w-auto flex items-center gap-4">
                                <div className="w-full md:w-auto md:w-32 bg-muted rounded-full h-2">
                                    <div
                                        className="h-2 bg-gradientPrimary rounded-full transition-all duration-500"
                                        style={{ width: `${Math.min(page.percentage, 100)}%` }}
                                    />
                                </div>
                                <Badge
                                    variant="default"
                                    className={`${page.change > 0 ? "bg-success/10 text-success group-hover:bg-success/20" : "bg-destructive/10 text-destructive group-hover:bg-destructive/20"} `}
                                >
                                    {page.change}%
                                </Badge>
                            </div>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
}

export default DomainList